import moment from 'moment';
import { TableCell, Tooltip } from '@material-ui/core';

function TimeAgoTableCell(props) {
	const isInDay = (date) => { return moment().diff(moment(date), 'days') <= 1; };

	const value = props.item[props.config.key];

	return (
		<TableCell className='p-4 md:p-16' scope='row'>

			{isInDay(value) && <div className='flex items-center'>
				<Tooltip title={moment(value).format('YYYY.M.DD HH:mm:ss')} placement='bottom'>
					<div>{moment(value).fromNow()}</div>
				</Tooltip>
			</div>}

			{!isInDay(value) && <div>{moment(value).format('YYYY.M.DD HH:mm:ss')}</div>}

		</TableCell>
	);
}

export default TimeAgoTableCell;